import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import NotifyCustomer from './component';
import style from '../style.module.less';

const notifyCustomer = {
  id: 'markAsShipped.columns.notifyCustomer',
  defaultMessage: 'Notify Customer',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(notifyCustomer);
};

export default {
  id: 'mark-as-shipped-notifyCustomer',
  index: 6,
  isDragable: false,
  minWidth: 100,
  width: 100,
  nonsortable: true,
  getName: GetName,
  name: (
    <div className={style['long-column-header']}>
      <FormattedMessage {...notifyCustomer} />
    </div>
  ),
  render: (data) => {
    return <NotifyCustomer fulfillmentPlanId={data.id} />;
  },
};
